module.exports = __webpack_public_path__ + "img/accidentImg.c8dd7c99.png";